import { IBrand } from "@faire/web-api/indigofair/data/IBrand";
import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";

/**
 * The brand of the authenticated user, if applicable.
 */
export const getBrand = (): IBrand | undefined => getGlobalProperty("brand");
